<template>
	<div id="container" class="container">
		<myheader :ismenu="false"></myheader>
		<div class="bindpage">
			<div class="tsbox align-c">
				<img src="@/static/z-icon-bind.png" class="icon" />
				<div class="k">
					<div class="t">账号关系绑定</div>
					<div class="t2">第三方应用授权认证通过后将绑定与主账号的关系，如未设置主账号，则需创建主账号，账号关系绑定后可通过第三方应用授权登录本平台</div>
				</div>
			</div>

			<div class="btob vcenter">
				<div class="align-c">
					<div class="item">
						<img src="@/static/z-icon-wx.png" class="bindimg" />
						<div class="t vcenter">独孤一方</div>
					</div>
					<img src="@/static/z-icon-bind2.png" class="icon" />
					<div class="item">
						<img src="@/static/z-icon-logo3.png" class="bindimg" />
						<div class="t vcenter">环太湖艺术动产</div>
					</div>
				</div>
			</div>

			<div class="title">环太湖艺术动产登记平台主账号：</div>
			<div class="bindform">
				<el-form ref="form" :rules="rules" :model="form" label-width="100px" label-position="left">
					<el-form-item prop="mobile" label="手机号：" class="elitem">
						<el-input v-model="form.mobile" maxlength="11" placeholder="请输入已注册的手机号码">
							<img slot="prefix" src="@/static/z-icon-tel.png" class="icon"></img>
						</el-input>
						<el-button class="vcodebtn cur curadm" @click="checkaccount">帐号检测</el-button>
					</el-form-item>
					<div class="creat align-c">
						<img src="@/static/z-icon-gth.png" class="icon" />
						<div class="t">未检测到平台主账号信息，</div>
						<div class="t2 cur curadm" @click="iscreat=true">立即创建</div>
					</div>
					<template v-if="iscreat">
						<el-form-item prop="password" label="密码：">
							<el-input v-model="form.password" type="password" show-password placeholder="请输入6位以上的字母数字组合密码">
								<img slot="prefix" src="@/static/z-icon-pass.png" class="icon"></img>
							</el-input>
						</el-form-item>
						<el-form-item prop="confirmpassword" label="确认密码：">
							<el-input v-model="form.confirmpassword" type="password" show-password placeholder="请再次输入密码">
								<img slot="prefix" src="@/static/z-icon-pass.png" class="icon"></img>
							</el-input>
						</el-form-item>
					</template>
				</el-form>
				<div class="btn-box vcenter">
					<el-button type="primary" class="green curadm" @click="onSubmit_bind">确认绑定</el-button>
				</div>
			</div>

		</div>
		<myfooter2></myfooter2>
	</div>
</template>

<script>
	import ty from "@/utils/ty/ty"
	import util from "@/common/util.js"
	export default {
		data() {
			return {
				iscreat:false,
				form: {
					mobile: "",
					password: "",
					confirmpassword: "",
				},
				rules: {
					mobile: [{
						required: true,
						message: '请输入手机号码',
						trigger: 'blur'
					}, {
						validator: (rule, value, callback) => {
							if (!util.checkPhone(value)) {
								callback(new Error('请输入正确的手机号码'));
							} else {
								callback();
							}
						},
						trigger: 'change'
					}],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}, ],
					confirmpassword: [{
						required: true,
						message: '请再次输入密码',
						trigger: 'blur'
					}, ],
				}
			}
		},
		mounted() {

		},
		methods: {
			onSubmit_bind() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						util.valert('绑定成功');
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			checkaccount(){
				
			},
		}
	}
</script>

<style lang="scss">
	@import "../style.scss";
	@import "bind.scss";
</style>